import { ListOfPropertiesValues } from "./ListOfPropertiesValues";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { Http } from "@status/codes";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import { AxiosError } from "axios";
import { CampusService } from "@/modules/Campus/services/CampusService";
import { LIST_ACCESS } from "@/modules/List/constants/ListConstants";
import { LACK_OF_OPTIONS } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { STATE } from "@/shared/constants/GeneralConstants";
import { ServiceTemplateService } from "@/modules/ServiceTemplate/services/ServiceTemplateService";
import { SERVICE_TEMPLATES_ACCESS } from "@/modules/ServiceTemplate/constants/ServiceTemplateConstants";

import { SectionOfDashboard } from "@/modules/DashboardTemplate/models/SectionOfDashboard";
import store from "@/store";
import { GENERAL_RULES_CONSTANTS } from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import { FIELD_WITHOUT_DATA } from "@/modules/DashboardTemplate/constants/DashboardTemplatesConstants";

export class OrdersPropertiesValues extends ListOfPropertiesValues {
  get sectionsOfDashboardStore(): Array<SectionOfDashboard> {
    return store.getters.getSectionsOfdashboard;
  }

  cups = this.findCups;
  campusId = this.getAllCampus;
  serviceTemplateId = this.getServiceTemplates;
  changedBy = this.getUsers;
  createdBy = this.getUsers;
  billType = (list: string) =>
    this.getList(list) as Promise<{ data: DynamicSelectData[] }>;
  diagnosticPrimaryCode = (list: string) =>
    this.getList(list) as Promise<{ data: DynamicSelectData[] }>;
  event = null;
  orderType = (list: string) =>
    this.getList(list) as Promise<{ data: DynamicSelectData[] }>;
  priceLevel = (list: string) =>
    this.getList(list) as Promise<{ data: DynamicSelectData[] }>;
  type = null;
  user = this.getUsers;
  state = (list: string) =>
    this.getList(list) as Promise<{ data: DynamicSelectData[] }>;

  indexOfItem = {};
  datastored: { [key: string]: DynamicSelectData } = {};
  indexCollection = 0;
  indexSectionOfDashboard = 0;
  keyword = "";
  lastRef = "";

  async loadItems(
    field: string,
    idList?: string,
    keyWord?: string
  ): Promise<{ data: DynamicSelectData[] }> {
    if (keyWord) {
      return await this[field as keyof OrdersPropertiesValues](keyWord);
    }

    if (this.keyword) {
      this.keyword = "";
      this.lastRef = "";
    }

    return await this[field as keyof OrdersPropertiesValues](idList);
  }

  findCups() {
    return this.getCups();
  }

  async getAllCampus() {
    try {
      const campusService = new CampusService();
      const response = await campusService.getAllCampus();
      if (response.code === Http.Found && response.data) {
        const campus = response.data;
        const campusList: DynamicSelectData[] = [];
        campus.forEach(({ key, name }) => {
          campusList.push({ id: key, name });
        });
        campusList.push(FIELD_WITHOUT_DATA);
        return { data: campusList };
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getServiceTemplates() {
    try {
      const serviceTemplateService = new ServiceTemplateService();
      const response = await serviceTemplateService.getAllActiveServiceTemplate(
        STATE.ACTIVE
      );
      if (response.code === Http.Found && response.data) {
        const serviceTemplatesList: DynamicSelectData[] = [];
        response.data.forEach(({ id, internalName }) => {
          serviceTemplatesList.push({
            id: id as string,
            name: internalName
          });
        });
        serviceTemplatesList.push(FIELD_WITHOUT_DATA);
        return { data: serviceTemplatesList };
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SERVICE_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getUsers(name?: string) {
    return await this.getUserByQuery(this.setFilters.bind(this), name);
  }

  setIndexes(
    indexSectionOfDashboard: number,
    indexCollectionFilter: number
  ): void {
    this.indexSectionOfDashboard = indexSectionOfDashboard;
    this.indexCollection = indexCollectionFilter;
  }

  setFilters(keyLastRef: string, name?: string) {
    const filterQuery: any = {
      state: GENERAL_RULES_CONSTANTS.ACTIVO
    };

    if (name && this.keyword !== name) {
      this.keyword = name;
      filterQuery.name = name;
      delete filterQuery[keyLastRef];
      return filterQuery;
    }

    if (name) {
      filterQuery.name = name;
      if (this.keyword !== name) {
        this.keyword = name;
      }
      return filterQuery;
    }

    return filterQuery;
  }
}
